import "../index.css";
import SearchBar from "@/components/SearchBar.tsx";
import React, { useEffect, useState, useRef } from "react";
import AuthService from "@/services/auth.ts";
import eventBus from "@/utils/eventBus.ts";
import type { ConversationParams, CreateQuestionRequest } from "@/types";
import { aiApi } from "@/api/aiApi.ts";
import { useNavigate, useParams } from "react-router-dom";
import { useGlobalStore } from "@/store/store.ts";
import Header from "@/components/header.tsx";
import { useTranslation } from "@/locales";
import { BrandLogo } from "@/components/SourceSystemBrand";

export default function HomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const userInfo = useGlobalStore((state) => state.user);
  const token = AuthService.getAccessToken();

  const handleSend = async (query: string, modelCode?: string): Promise<void> => {
    if (!query.trim()) return;
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    if (!userInfo) return;

    const params: ConversationParams = { question: query, model: modelCode };
    const res = (await aiApi.conversation.create(params)) as CreateQuestionRequest | null;
    localStorage.setItem("question", query);
    localStorage.setItem(
      "queryParams",
      JSON.stringify({
        conversationNo: res?.conversationNo,
        question: query,
      })
    );
    eventBus.emit("search", query);
    navigate(`/${res?.topicNo}`);
  };

  return (
    <div className="bg-[var(--background-page_background_web)] flex-1 flex flex-col">
      <Header />
      <div className="flex flex-1">
        <div className="flex-1 px-4 flex flex-col home-content">
          <div className="flex-1 min-h-[56px]"></div>
          <div className="mb-10 flex flex-col">
            <div className="m-auto">
              <div className="flex mb-10 max-w-[1017px]">
                <BrandLogo className="w-[32px] h-[32px]" />
                <div className="ml-4">
                  <div>{t("home.greeting")}</div>
                  <div>{t("home.description")}</div>
                </div>
              </div>
            </div>
            <div>
              <SearchBar onSearch={handleSend} />
            </div>
          </div>
          <div className="flex-1"></div>
        </div>
      </div>
    </div>
  );
}
